<template>
  <el-popover
    v-if="!disabled"
    ref="popover"
    v-model="popover"
    placement="top-end"
    width="200"
    :title="title"
  >
    <v-switch slot="reference" :value="value" />

    <template>
      <v-row justify="between">
        <v-button theme="primary" view="transparent" @click="popover = false">{{ localCancelText }}</v-button>
        <v-button theme="primary" @click="handleClick">{{ localAcceptText }}</v-button>
      </v-row>
    </template>
  </el-popover>
  <v-switch v-else :value="value" :disabled="disabled" />
</template>

<script>
import VSwitch from '@/components/common/VSwitch.vue'
import VRow from '@/components/common/VRow.vue'

export default {
  name: 'VSwitchWithPopover',

  components: {
    VSwitch,
    VRow
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    acceptText: {
      type: String
    },

    cancelText: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      popover: false
    }
  },

  computed: {
    localAcceptText() {
      return this.acceptText || this.$t('c.popover.acceptText')
    },
    localCancelText() {
      return this.cancelText || this.$t('c.popover.cancelText')
    }
  },

  methods: {
    handleClick() {
      this.popover = false
      this.$emit('change', !this.value)
    }
  }
}
</script>
